var _path, _path2, _ellipse, _circle, _ellipse2, _ellipse3, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateCantResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 44.9999C107.7 34.1999 84.4998 49.6787 73 61.9999C67.9998 67.3572 65.6 72.1999 64 82.9999C62 96.4999 71.9999 113 85.9999 120C99.9999 127 115.089 106.529 128.5 90.9999C147.5 68.9999 136.5 58.4999 120.5 44.9999Z",
    fill: "CurrentColor",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 77C78.5 77 81.5 101 76.7024 124C71.9049 147 28 98.0145 28 71.7647C28 45.5149 46.8783 35 73 35C112.449 35 151.5 77 115 77Z",
    fill: "CurrentColor",
    fillOpacity: 0.07
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6822,
    cy: 68.7792,
    rx: 9.3478,
    ry: 11.2174,
    transform: "rotate(20.4825 44.6822 68.7792)",
    fill: "url(#paint0_linear_18996_49927)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.016,
    cy: 30.016,
    r: 3.01598,
    fill: "url(#paint1_linear_18996_49927)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.396,
    cy: 133.442,
    rx: 4.47637,
    ry: 6.26692,
    transform: "rotate(20.6101 82.396 133.442)",
    fill: "url(#paint2_linear_18996_49927)",
    fillOpacity: 0.07
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.0467,
    cy: 140.708,
    rx: 2.83209,
    ry: 3.96493,
    transform: "rotate(20.6101 96.0467 140.708)",
    fill: "url(#paint3_linear_18996_49927)",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 112.375C97.8802 112.375 112.375 97.8802 112.375 80C112.375 62.1198 97.8802 47.625 80 47.625C62.1198 47.625 47.625 62.1198 47.625 80C47.625 97.8802 62.1198 112.375 80 112.375ZM80 117C100.435 117 117 100.435 117 80C117 59.5655 100.435 43 80 43C59.5655 43 43 59.5655 43 80C43 100.435 59.5655 117 80 117Z",
    fill: "CurrentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7322 93.8449C61.7559 94.8212 61.7559 96.4042 62.7322 97.3805C63.7085 98.3568 65.2915 98.3568 66.2678 97.3805L80.0001 83.6482L93.845 97.4931C94.8214 98.4694 96.4043 98.4694 97.3806 97.4931C98.3569 96.5168 98.3569 94.9339 97.3806 93.9576L83.5356 80.1126L97.3805 66.2678C98.3568 65.2915 98.3568 63.7085 97.3805 62.7322C96.4042 61.7559 94.8212 61.7559 93.8449 62.7322L80.0001 76.5771L66.2679 62.8449C65.2916 61.8686 63.7087 61.8686 62.7323 62.8449C61.756 63.8212 61.756 65.4041 62.7323 66.3804L76.4645 80.1126L62.7322 93.8449Z",
    fill: "CurrentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18996_49927",
    x1: 44.0163,
    y1: 78.8084,
    x2: 32.1535,
    y2: 59.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CurrentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18996_49927",
    x1: 98.8011,
    y1: 32.7125,
    x2: 95.8934,
    y2: 27.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CurrentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18996_49927",
    x1: 82.0771,
    y1: 139.045,
    x2: 75.0578,
    y2: 129.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CurrentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18996_49927",
    x1: 95.8449,
    y1: 144.253,
    x2: 91.4039,
    y2: 138.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CurrentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCantResult);
export default __webpack_public_path__ + "static/media/emptyStateCantResult.57f283e7.svg";
export { ForwardRef as ReactComponent };